import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { customerContainer } from 'src/models'
import { accountOverviewFormData } from './formData'
import { MetaDecorator } from '../../../components/MetaDecorator'
import AccountForm from './AccountForm'
import EventStaticMyProfile from './EventStaticMyProfile'
import { accountOverviewFormDataSMSverify } from './formDataSMSverify'
import AccountFormSMSverify from './AccountFormSMSverify'
import { i18nTranslate, enablePhoneVerification } from 'src/utils'
import { getLiveEventStatus } from 'src/utils'
import { userDetailsformInput } from './formInput'
import './styles.scss'

@observer
class MyAccountProfile extends React.Component {
  @observable data = {}
  @observable enableLiveEvent = getLiveEventStatus()

  @observable formRef = React.createRef()
  @observable phoneVerifyFormdata = {}

  componentDidMount() {
    this.checkAndInitProfile()
  }

  checkAndInitProfile() {
    const customerResponse =
      customerContainer?.profileResponse?.customer ||
      customerContainer?.profileResponse

    if (customerResponse?.id) {
      this.getFormData()
    } else {
      setTimeout(() => {
        this.checkAndInitProfile()
      }, 300)
    }
  }

  /**
   * @info Get static and API data for the form
   *
   */
  async getFormData() {
    try {
      let response = await this.getDataModal()
      this.data = response
    } catch (err) {
      console.log('Error ', err)
    }
  }

  /**
   * @info To re-render the component on updating the form from child component
   *
   */
  async handleChildUpdate() {
    await this.getFormData()
  }

  async getDataModal() {
    const profileResponse = customerContainer.profileResponse
    let userFormData
    if (enablePhoneVerification() && this.enableLiveEvent !== 'true') {
      userFormData = await accountOverviewFormDataSMSverify(
        profileResponse,
        this.getFormRefData
      )
    } else if (this.enableLiveEvent === 'true') {
      userFormData = (await userDetailsformInput(profileResponse)) || {}
    } else {
      userFormData = (await accountOverviewFormData(profileResponse)) || {}
    }
    return {
      title: i18nTranslate(
        'myAccountMyProfilePage.title',
        'My Profile | Nu Skin'
      ),
      description: 'My Profile Page',
      userFormData: userFormData,
    }
  }

  getFormRefData = formData => {
    this.phoneVerifyFormdata = formData
      ? formData
      : this.formRef.current?.values
  }

  renderAccountProfile() {
    if (enablePhoneVerification()) {
      return (
        <AccountFormSMSverify
          {...this.data?.userFormData}
          onUpdate={() => {
            this.handleChildUpdate()
          }}
          dataTestId="qa-my-profile"
          formRef={this.formRef}
          getFormRefData={this.getFormRefData}
          phoneVerifyFormdata={this.phoneVerifyFormdata}
        />
      )
    } else {
      return (
        <AccountForm
          {...this.data?.userFormData}
          onUpdate={() => {
            this.handleChildUpdate()
          }}
          dataTestId="qa-my-profile"
        />
      )
    }
  }

  render() {
    //const data = this.getDataModal()

    return (
      <>
        <MetaDecorator
          title={this.data?.title}
          description={this.data?.description}
          data-testId="qa-my-profile"
          location={this.props}
        />
        <div className="account-wrapper">
          {this.enableLiveEvent === 'true' ? (
            <EventStaticMyProfile data={this.data?.userFormData} />
          ) : (
            this.data?.userFormData && this.renderAccountProfile()
          )}
        </div>
      </>
    )
  }
}

export { MyAccountProfile }
export default MyAccountProfile
